import axios from '../utils/axios';

export default function updateIntegration(adminId, integrationId, data) {
    return (
        axios.post(`/admin/${adminId}/ats-integrations/${integrationId}`,  data )
    )
}
